const Decentradot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
    <path fill="#fff" d="M0 0h512v512H0z" />
    <path
      d="M141.22 94.56a37.39 37.39 0 0 1 32.36-18.68h164.84a37.39 37.39 0 0 1 32.36 18.68l82.42 142.76a37.38 37.38 0 0 1 0 37.36l-82.42 142.76a37.39 37.39 0 0 1-32.36 18.68H173.58a37.39 37.39 0 0 1-32.36-18.68L58.81 274.68a37.33 37.33 0 0 1 0-37.36z"
      fill="#ed1382"
    />
  </svg>
);

export default Decentradot;
